import React from "react";
import { SettingsScreen } from "~/features/settings/SettingsScreen";

const Component = () => {
  return <SettingsScreen />;
};

export default Component;
